import { type Route } from '@angular/router';
import { newsCategoryRoutes } from './category/news-category.routes';
import {
  hasStringPathParamCanActivateGuard,
  sequentialDeactivateGuards,
} from '@pct-ng/core/router';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';
import { showToasterDeactivateGuard } from '@pct-ng/form';

export const newsRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/news-list.component').then(({ NewsListComponent }) => NewsListComponent),
    pathMatch: 'full',
  },
  {
    path: 'category',
    children: newsCategoryRoutes,
    title: 'PAGES.NEWS.CATEGORY.BREADCRUMB.LIST',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/news-details.component').then(
        ({ NewsDetailsComponent }) => NewsDetailsComponent,
      ),
    title: 'PAGES.NEWS.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.NEWS.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/news-details.component').then(
        ({ NewsDetailsComponent }) => NewsDetailsComponent,
      ),
    title: 'PAGES.NEWS.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.NEWS.SINGULAR'),
      ]),
    ],
  },
];
